import { render, staticRenderFns } from "./doneDispatch.vue?vue&type=template&id=49b0bc35"
import script from "./doneDispatch.vue?vue&type=script&lang=js"
export * from "./doneDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports